import { render } from "./FooterPrincipal.vue?vue&type=template&id=3e1379a3&scoped=true"
import script from "./FooterPrincipal.vue?vue&type=script&lang=js"
export * from "./FooterPrincipal.vue?vue&type=script&lang=js"

import "./FooterPrincipal.vue?vue&type=style&index=0&id=3e1379a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1379a3"]])

export default __exports__